/**
 * Donation Product Remapper
 * Flutter: lib/data/models/donation_product.dart
 */
import type { DonationProductDto } from '@/data/dtos/donationProduct/donationProductDto';
import type { JsonObject } from '@/data/types/json';
import type { DonationProductStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class DonationProductRemapper {
  static toStorage(dto: DonationProductDto): DonationProductStorage {
    return {
      name: dto.name,
      order: dto.order,
      price: dto.price,
      productId: dto.productId,
      currency: dto.currency,
      currencySymbol: dto.currencySymbol,
    };
  }

  static fromJson(data: JsonObject): DonationProductDto {
    return {
      name: (data['name'] as string | undefined) ?? '',
      order: (data['order'] as number | undefined) ?? 0,
      price: (data['price'] as number | undefined) ?? 0,
      productId: (data['productId'] as string | undefined) ?? '',
      currency: (data['currency'] as string | undefined) ?? '',
      currencySymbol: (data['currencySymbol'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): DonationProductDto[] {
    return dataList.map(DonationProductRemapper.fromJson);
  }
}
